import { render, staticRenderFns } from "./NewPlanCategory.vue?vue&type=template&id=511fe08c&"
import script from "./NewPlanCategory.vue?vue&type=script&lang=js&"
export * from "./NewPlanCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports